<template>
  <ButtonBase
    theme="secondary"
    class="item"
    size="small"
    stroke="m"
    variant="outlined"
    :rounded="true"
    :single-line="true"
    :to="routeLink.path"
    @click.capture="handleClickPath"
  >
    {{ category.title }}
  </ButtonBase>
</template>
<script setup lang="ts">
interface Props {
  category: CategorySchema;
}
const props = defineProps({
  category: null
});
const { handleClickPath, routeLink } = await useCategoryLinkTryAndLock(
  props.category
);
</script>
